import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { ImageResizable } from "../components/elements/ImageResizeable";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useDidMountEffect } from "../customHooks/useDidMountEffect.js";
import { GroupDetails } from "../components/elements/GroupStatsDisplay/GroupDetails.js";

export const TinyTripFriend = ({ friend_id, friend_image, friend_name, friend_display_name, friend_book_date, trip_id, style }) => {
    const { t } = useTranslation();
    const renderFriendName = friend_display_name || friend_name;

    const [openGroupDetails, setOpenGroupDetails] = useState(false);
    const handleOpenGroupDetails = () => {
        setOpenGroupDetails(true);

        // add to window history stack
        window.history.pushState(
            {
                modal: "opened",
            },
            "",
            ""
        );
    };
    const handleCloseGroupDetails = () => {
        window.history.back();
    };
    useDidMountEffect(() => {
        const handleClosePop = () => {
            setOpenGroupDetails(false);
        };

        if (openGroupDetails) {
            // when back button pressed, what to do
            window.addEventListener("popstate", handleClosePop);
        } else {
            window.removeEventListener("popstate", handleClosePop);
        }
    }, [openGroupDetails]);

    if (!friend_id) return null;

    const timeAgo = dayjs(friend_book_date).fromNow();

    const getActivityContent = () => {
        switch ('book') {
            case "interested_in":
                return {
                    icon: "👀",
                    textColor: "tw-text-yellow-700",
                    message: "is browsing",
                    actionText: "Interested",
                    actionClass: "tw-bg-yellow-100 tw-text-yellow-800",
                    activityTranslation: "is_browsing",
                    actionTranslation: "interested",
                };
            case "book":
            case "confirmed":
                return {
                    icon: "✨",
                    textColor: "tw-text-blue-700",
                    message: "secured a spot",
                    actionText: "Booked",
                    actionClass: "tw-bg-blue-100 tw-text-blue-800",
                    activityTranslation: "secured_spot",
                    actionTranslation: "booked",
                };
            case "waitlisted":
                return {
                    icon: "🎯",
                    textColor: "tw-text-orange-700",
                    message: "is hoping to join",
                    actionText: "Waitlisted",
                    actionClass: "tw-bg-orange-100 tw-text-orange-800",
                    activityTranslation: "hoping_to_join",
                    actionTranslation: "waitlisted",
                };
            default:
                return null;
        }
    };

    const content = getActivityContent();

    if (!content) return null;

    const child = (
        <div
            style={style}
            className="tw-absolute tw-bottom-1 tw-right-1 tw-z-10 tw-flex tw-max-w-[95%] tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-gray-100 tw-bg-white/60 tw-px-2.5 tw-py-2 tw-shadow-md tw-backdrop-blur-sm tw-transition-all tw-duration-300"
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleOpenGroupDetails();
            }}
        >
            <div className="tw-relative">
                <ImageResizable
                    src={friend_image}
                    size="xs"
                    className="tw-h-7 tw-w-7 tw-rounded-full tw-border-2 tw-border-white tw-object-cover"
                />
            </div>

            <div className="tw-min-w-0 tw-flex-1">
                {isMobile ?
                    <div
                        style={{ fontSize: isMobile ? "10px" : "12px" }}
                    >
                        <span style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "flex-start" }} className="tw-font-medium">{renderFriendName}</span>&nbsp;
                        <span style={{ width: "100%" }} className={content.textColor}>
                            {t(content.activityTranslation, {
                                defaultValue: content.message,
                            })}
                        </span>
                    </div> : <div
                        style={{ fontSize: isMobile ? "10px" : "12px" }}
                    >
                        <span className="tw-font-medium">{renderFriendName}</span>&nbsp;
                        <span className={content.textColor}>
                            {t(content.activityTranslation, {
                                defaultValue: content.message,
                            })}
                        </span>
                    </div>
                }

                <div className="tw-mt-0.3 tw-flex tw-w-[100%] tw-items-center tw-justify-end tw-gap-2">
                    <span style={{ fontSize: isMobile ? "8px" : "10px" }} className="tw-text-gray-500">{timeAgo}</span>
                </div>
            </div>

            {openGroupDetails && (
                <GroupDetails
                    tripId={trip_id}
                    open={openGroupDetails}
                    handleClose={handleCloseGroupDetails}
                    friend_id={friend_id}
                />
            )}
        </div>
    );

    return child;
};
